// Ionic
import { IonContent, IonPage } from "@ionic/react";

// Components
import LoginComponent from "../components/Login/LoginComponent";

function Login(props) {
  return (
    <IonPage>
      <IonContent fullscreen>
        <LoginComponent />
      </IonContent>
    </IonPage>
  );
}

export default Login;
